import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import { PersistConfigModified } from './PersistConfigModified';

export const createPersistedReducer = <S>(config: PersistConfigModified<S>, reducer: Reducer<S>) => persistReducer(config, reducer);
